import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProfileComponent } from './profile.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { IntroComponent } from './intro/intro.component';
import { AboutComponent } from './about/about.component';

import { ExperienceComponent } from './experience/experience.component';

import { ReferenceComponent } from './reference/reference.component';
import { ContactComponent } from './contact/contact.component';
import { ProjectsComponent } from './projects/projects.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SplitPipe } from './split.pipe';
import { PaymentComponent } from './payment/payment.component';
import { QuizzesComponent } from './quizzes/quizzes.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule
  ],
  declarations: [
    ProfileComponent,
    HeaderComponent,
    FooterComponent,
    IntroComponent,
    AboutComponent,

    ExperienceComponent,
    ReferenceComponent,
    ContactComponent,
    ProjectsComponent,
    SplitPipe,
    PaymentComponent,
    QuizzesComponent
  ],
 
})
export class ProfileModule { }
